export default __webpack_public_path__ + "images/models/adc8e448f1882bc70586b6273e7bf6f6.glb";